import axios from "axios";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

import { userLogout } from "./user";
import { clearCheckout } from "./checkout";
import { getCart } from "./cart";

// Clear PickupDate
export const clearPickupDate = pickupDate => {
	return {
		type: "CLEAR_PICKUP_DATE",
		pickupDate
	};
}

// ===================================================================================
//  GET
// ===================================================================================
export const pickupOptionsLoading = () => {
	return {
		type: "PICKUP_OPTIONS_LOADING"
	};
};

export const pickupOptionsError = err => {
	return {
		type: "PICKUP_OPTIONS_ERROR",
		err
	};
};

export const pickupOptionsSuccess = data => {
	return {
		type: "PICKUP_OPTIONS_SUCCESS",
		data
	};
};

export function getPickupOptions() {
	return (dispatch, getState) => {
		dispatch(pickupOptionsLoading());

		// Set user token (account/guest)
		let token = "";
		if (getState().user.customer) token = getState().user.customer.token;
		else if (getState().user.guest) token = getState().user.guest.token;

		let AUTH_HEADER = {
			Authorization: REACT_APP_SITE_KEY + ":Bearer " + token
		};

		// Put data together to send
		let orderData = {};
		orderData.cart = getState().cart.shoppertrack;

		return axios
			.post(REACT_APP_API_URL + "pickup-options", orderData, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(clearCheckout());
						dispatch(userLogout(!!getState().user.customer ? "customer" : "guest"));
					}

					if (!!response.data.errors.general) {
						dispatch(pickupOptionsError(response.data.errors));
					} else {
						dispatch(pickupOptionsSuccess({ general: response.data.message }));
					}
				}
				// Success
				else {
					dispatch(pickupOptionsSuccess(response.data));
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				dispatch(pickupOptionsError({ general: err.response.statusText }));
			});
	};
}

// ===================================================================================
//  SET
// ===================================================================================
export const pickupSelectionLoading = () => {
	return {
		type: "PICKUP_SELECTION_LOADING"
	};
};

export const pickupOptionSelectionError = err => {
	return {
		type: "PICKUP_SELECTION_ERROR",
		err
	};
};

export const pickupOptionSelectionSuccess = data => {
	return {
		type: "PICKUP_SELECTION_SUCCESS",
		data
	};
};

export const setPickup = selection => {
	return {
		type: "SET_PICKUP",
		selection
	};
};

export const setPickupSaving = selection => {
	return {
		type: "SET_PICKUP_SAVING",
		selection
	};
};

export const setPickupSaved = selection => {
	return {
		type: "SET_PICKUP_SAVED",
		selection
	};
};


export function setPickupOption(selection) {
	return (dispatch, getState) => {
		dispatch(pickupSelectionLoading());

		dispatch(setPickup(selection));

		return dispatch(getCart(true)).then(() => {
			dispatch(setPickupSaved());
		});
	};
}

export function clearPickupOption() {
	return (dispatch, getState) => {
		dispatch(pickupSelectionLoading());

		// Set user token (account/guest)
		let token = "";
		if (getState().user.customer) token = getState().user.customer.token;
		else if (getState().user.guest) token = getState().user.guest.token;

		let AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		// Put data together to send
		let orderData = {};
		orderData.cart = getState().cart.shoppertrack;

		return axios
			.post(REACT_APP_API_URL + "pickup-options/clear", orderData, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(clearCheckout());
						dispatch(userLogout(!!getState().user.customer ? "customer" : "guest"));
					}

					if (!!response.data.errors.general) {
						dispatch(pickupOptionSelectionError(response.data.errors));
					} else {
						dispatch(
							pickupOptionSelectionError({
								general: response.data.message
							})
						);
					}
				}
				// Success
				else {}
			})
			.catch(err => {
				dispatch(pickupOptionSelectionError({ general: err.response.statusText }));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/pickup.js